/* Prepa Pizza: Mystery Gift keeper (v2, 2026-10-19).
   Rule: the free Mystery Gift is in the cart only while a subscription item is in the cart.
   - subscription in cart, no gift   -> add 1 gift
   - gift in cart, no subscription   -> remove gift
   - more than 1 gift                -> set to 1
   Runs on page load and after any cart change made through fetch or XHR (theme drawer, Seal widget, cart page).
   v2: the main kit page's Add to Cart goes straight to checkout, so v1 (which fixed the cart ~0.35 s later) missed it and
   1/3/6 subscriptions checked out without the gift. Now a fetch to /cart/add|change|update does not hand its answer back
   to the page until the gift is fixed, so any redirect to checkout happens after the gift is in. */
(function () {
  var GIFT = 53983061508389;
  var busy = null, timer = null;

  function isCartUrl(u) {
    return typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(u) && u.indexOf('prepa-gift') === -1;
  }

  function refreshUi() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {}
    if (/^\/cart\/?$/.test(location.pathname)) location.reload();
  }

  function post(url, body) {
    return origFetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'src=prepa-gift', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /* returns a promise that settles once the cart is right (never rejects) */
  function sync(ui) {
    if (busy) return busy;
    busy = origFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var hasSub = items.some(function (i) { return i.variant_id !== GIFT && i.selling_plan_allocation; });
        var gift = items.filter(function (i) { return i.variant_id === GIFT; })[0];
        var p = null;
        if (hasSub && !gift) p = post('/cart/add.js', { items: [{ id: GIFT, quantity: 1 }] });
        else if (!hasSub && gift) p = post('/cart/change.js', { id: gift.key, quantity: 0 });
        else if (gift && gift.quantity > 1) p = post('/cart/change.js', { id: gift.key, quantity: 1 });
        if (p) return p.then(function () { if (ui !== false) refreshUi(); });
      })
      .catch(function () {})
      .then(function () { busy = null; });
    return busy;
  }

  function later() { clearTimeout(timer); timer = setTimeout(sync, 350); }

  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (!isCartUrl(url)) return p;
    /* hold the page's own answer until the gift is fixed (max 4 s), so a redirect to checkout can't beat it */
    return p.then(function (res) {
      var done = sync(false).then(function () { later(); return res; });
      var cap = new Promise(function (ok) { setTimeout(function () { ok(res); }, 4000); });
      return Promise.race([done, cap]);
    });
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartUrl(String(url))) this.addEventListener('loadend', later);
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(); });
  else sync();
})();
